module.exports = "data:image/gif;base64,R0lGODlhCQAJAMQaAJSUlGZmZlZWVoSEhI+Pj09PT5qammRkZKampl9fX3x8fL29vYyMjK+vr29vb4GBgXd3d7S0tHZ2dpycnKqqqoODg3R0dI6OjlRUVJaWlv///wAAAAAAAAAAAAAAAAAAACH5BAEAABoALAAAAAAJAAkAAAUvoKYZADEMoggsUeOkGrEgzAEP1FUlIknQikLCZslMHpJAISVQQJQwjSCAiYoEsBAAOw=="


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/grid/col-move-top.gif
 ** module id = 420
 ** module chunks = 0
 **/